/* JOEKR Luxury PDP (P5) — FLIPズーム + バリアント切替 + カート */
(() => {
  const pdps = document.querySelectorAll('.jpdp');
  if (!pdps.length) return;

  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // main-product-joekr.liquid の初期表示と同じ文字列
  const L = { add: 'カートに入れる / Add to Cart', sold: '完売 / Sold Out', adding: '追加しています…', added: 'カートに入れました', checkout: 'ご購入手続きへ' };

  pdps.forEach(pdp => {
    const form = pdp.querySelector('.jpdp__form');
    const sticky = pdp.querySelector('.jpdp__sticky');
    const sBtn = sticky?.querySelector('.jpdp__sticky-btn');
    const sLbl = sticky?.querySelector('.jpdp__sticky-label');
    const mBtn = pdp.querySelector('.jpdp__cart-btn');
    const mLbl = pdp.querySelector('.jpdp__cart-btn-label');
    const addedEl = pdp.querySelector('.jpdp__added');
    // カートに入った後の固定バーは「ご購入手続きへ」（カート通知を閉じた後も決済への導線を残す）
    let toCheckout = !!sticky?.classList.contains('is-checkout');
    // 売切れのバリアントでは押せないバーを出さない
    let below = false;
    let sold = !toCheckout && !!sBtn?.disabled;
    const show = () => {
      if (!sticky) return;
      const on = below && (toCheckout || !sold);
      sticky.classList.toggle('is-shown', on);
      sticky.inert = !on;
      sticky.setAttribute('aria-hidden', String(!on));
    };
    // 固定バーは和文のみ
    const paint = (t, off) => {
      if (mLbl) mLbl.textContent = t;
      if (sLbl && !toCheckout) sLbl.textContent = t.split(' / ')[0];
      if (off != null) {
        [mBtn, toCheckout ? null : sBtn].forEach(b => { if (b) b.disabled = off; });
        sold = t === L.sold;
        show();
      }
    };

    // ---------- スマホ追従 CTA（P12） ----------
    if (sticky && mBtn && window.IntersectionObserver) {
      new window.IntersectionObserver(([e]) => {
        below = !e.isIntersecting && e.boundingClientRect.top < 0;
        show();
      }).observe(mBtn);
    }
    // 未入力の必須項目（サイズ・バングルの実寸）へ戻す。固定バーから送信したときフォームは画面外にある
    const VARIANT_CTRL = '.jpdp__variant-input, .jpdp__variant-select';
    const markVariant = (ctrl, on) => {
      const g = ctrl.closest('.jpdp__variant-group');
      if (!g) return;
      g.classList.toggle('is-invalid', on);
      const err = g.querySelector('.jpdp__variant-error');
      if (err) err.hidden = !on;
      g.querySelectorAll(VARIANT_CTRL).forEach(c => { if (on) c.setAttribute('aria-invalid', 'true'); else c.removeAttribute('aria-invalid'); });
    };
    let scrolledToInvalid = false;
    form?.addEventListener('invalid', e => {
      const t = e.target;
      const isVariant = t.matches(VARIANT_CTRL);
      if (isVariant) { e.preventDefault(); markVariant(t, true); }
      if (scrolledToInvalid) return;
      scrolledToInvalid = true;
      setTimeout(() => { scrolledToInvalid = false; }, 0);
      (isVariant ? t.closest('.jpdp__variant-group') : t).scrollIntoView({ block: 'center' });
      if (isVariant) t.focus({ preventScroll: true });
    }, true);

    // ---------- バリアント切替 ----------
    const wristSelect = pdp.querySelector('.jpdp__wrist-select');
    const wristOther = pdp.querySelector('.jpdp__wrist-other');
    if (wristSelect && wristOther) {
      const wristInput = wristOther.querySelector('.jpdp__wrist-input');
      const syncWristOther = () => {
        const on = wristSelect.value === 'その他';
        wristOther.hidden = !on;
        if (wristInput) { wristInput.disabled = !on; wristInput.required = on; if (!on) wristInput.value = ''; }
      };
      wristSelect.addEventListener('change', syncWristOther);
      syncWristOther();
    }
    if (form && window.__product_data__) {
      const inputs = form.querySelectorAll(VARIANT_CTRL);
      const variantIdInput = form.querySelector('.jpdp__variant-id');
      const priceEls = pdp.querySelectorAll('.jpdp__price, .jpdp__sticky-price');
      function selectedOptions() {
        const opts = [];
        inputs.forEach(i => {
          if (i.tagName === 'SELECT' || i.checked) opts[parseInt(i.dataset.optionIndex, 10)] = i.value;
        });
        return opts;
      }
      function findVariant() {
        const opts = selectedOptions();
        return window.__product_data__.variants.find(v =>
          v.options.every((o, i) => o === opts[i])
        );
      }
      inputs.forEach(i => i.addEventListener('change', () => {
        markVariant(i, false);
        const v = findVariant();
        variantIdInput.value = v ? v.id : '';
        if (!v) return;
        if (priceEls.length && v.price != null) {
          const formatted = (window.__product_data__.prices || {})[v.id];
          let txt;
          if (formatted) {
            const tmp = document.createElement('span');
            tmp.innerHTML = formatted;
            txt = tmp.textContent;
          } else {
            txt = '¥' + (v.price / 100).toLocaleString('ja-JP');
          }
          priceEls.forEach(p => { p.textContent = txt; });
        }
        paint(v.available ? L.add : L.sold, !v.available);
      }));
    }

    // ---------- AJAX カート追加 ----------
    if (form) {
      const errEl = form.querySelector('.jpdp__form-error');
      const idInput = form.querySelector('.jpdp__variant-id');
      const routes = window.routes || {};
      const addUrl = (routes.cart_add_url || '/cart/add') + '.js';
      const cartUrl = routes.cart_url || '/cart';
      const genericError = 'カートに追加できませんでした。時間をおいて再度お試しください。';
      let busy = false;

      // 固定バーから送信したときはフォームが画面外にあるため、エラーを画面内へ寄せる
      const showError = (msg) => {
        if (!errEl) return;
        errEl.textContent = msg || '';
        errEl.hidden = !msg;
        if (!msg) return;
        const r = errEl.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) errEl.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      const restore = () => {
        const variants = window.__product_data__?.variants || [];
        const v = variants.find(x => String(x.id) === idInput?.value);
        const available = v ? v.available : true;
        paint(available ? L.add : L.sold, !available);
        busy = false;
      };

      form.addEventListener('submit', async (e) => {
        // サイズ未確定のまま送らない（検証をすり抜けた場合の保険）
        if (idInput && !idInput.value) {
          e.preventDefault();
          if (form.reportValidity()) showError(genericError);
          return;
        }
        if (!window.fetch) return; // フォールバックは通常のPOST
        e.preventDefault();
        if (busy) return;
        busy = true;
        showError('');
        paint(L.adding, true);

        const fd = new FormData(form);
        // Dawn のカート通知（cart_type: notification）。drawer 設定時は cart-drawer が同じ API を持つ
        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart) {
          try {
            fd.append('sections', cart.getSectionsToRender().map(s => s.id).join(','));
            fd.append('sections_url', window.location.pathname);
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
          } catch (err) {
            cart = null;
          }
        }

        let res;
        let data = null;
        try {
          res = await fetch(addUrl, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
          data = await res.json().catch(() => null);
        } catch (err) {
          restore();
          showError(genericError);
          return;
        }

        if (!res.ok || (data && data.status)) {
          const detail = data && [data.description, data.message].find(m => typeof m === 'string' && m);
          restore();
          showError(detail || genericError);
          return;
        }

        window.dispatchEvent(new CustomEvent('cart:added'));
        if (sBtn && sticky.dataset.checkoutForm) {
          toCheckout = true;
          sticky.classList.add('is-checkout');
          sBtn.setAttribute('form', sticky.dataset.checkoutForm);
          sBtn.disabled = false;
          if (sLbl) sLbl.textContent = L.checkout;
        }
        if (addedEl) addedEl.hidden = false;
        paint(L.added);

        let shown = false;
        if (cart && data && data.sections) {
          try {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
            shown = true;
          } catch (err) {
            shown = false;
          }
        }
        if (!shown) {
          // 通知を出せない場合は必ずカートページへ
          window.addEventListener('pageshow', (ev) => { if (ev.persisted) restore(); }, { once: true });
          window.location.href = cartUrl;
          return;
        }
        setTimeout(restore, 1600);
      });
    }

    // ---------- FLIP ズーム ----------
    const lightbox = pdp.querySelector('.jpdp__lightbox');
    const lbInner = lightbox?.querySelector('.jpdp__lightbox-inner');
    const closeBtn = lightbox?.querySelector('.jpdp__lightbox-close');
    if (!lightbox || !lbInner) return;

    const triggers = pdp.querySelectorAll('[data-flip-trigger]');
    let openTrigger = null;

    function openZoom(btn) {
      if (reduceMotion) return openZoomSimple(btn);
      const img = btn.querySelector('img');
      if (!img) return;
      const url = btn.dataset.imageUrl || img.src;
      const alt = btn.dataset.imageAlt || img.alt;
      const startRect = img.getBoundingClientRect();

      // 1. lightbox にターゲットを配置（最終位置）
      lbInner.innerHTML = '';
      const clone = document.createElement('img');
      clone.src = url;
      clone.alt = alt;
      clone.style.opacity = '0';
      lbInner.appendChild(clone);
      lightbox.setAttribute('aria-hidden', 'false');
      openTrigger = btn;

      // 2. ライトボックス内のターゲット位置を計測
      clone.onload = () => {
        const endRect = clone.getBoundingClientRect();
        // 3. FLIP: ターゲットを開始位置に瞬時に移動
        const dx = startRect.left - endRect.left;
        const dy = startRect.top - endRect.top;
        const sx = startRect.width / endRect.width;
        const sy = startRect.height / endRect.height;
        clone.style.transformOrigin = 'top left';
        clone.style.transform = `translate(${dx}px, ${dy}px) scale(${sx}, ${sy})`;
        clone.style.transition = 'none';
        clone.style.opacity = '1';
        // 4. 次フレームで最終位置にアニメ
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            clone.style.transition = 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)';
            clone.style.transform = 'none';
          });
        });
      };
      // src が cached の場合
      if (clone.complete) clone.onload();
      document.body.style.overflow = 'hidden';
    }

    function openZoomSimple(btn) {
      const url = btn.dataset.imageUrl;
      const alt = btn.dataset.imageAlt || '';
      lbInner.innerHTML = `<img src="${url}" alt="${alt.replace(/"/g, '&quot;')}" />`;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      openTrigger = btn;
    }

    function closeZoom() {
      if (reduceMotion || !openTrigger) {
        lightbox.setAttribute('aria-hidden', 'true');
        lbInner.innerHTML = '';
        document.body.style.overflow = '';
        openTrigger = null;
        return;
      }
      const clone = lbInner.querySelector('img');
      const startRect = openTrigger.querySelector('img')?.getBoundingClientRect();
      const endRect = clone?.getBoundingClientRect();
      if (clone && startRect && endRect) {
        const dx = startRect.left - endRect.left;
        const dy = startRect.top - endRect.top;
        const sx = startRect.width / endRect.width;
        const sy = startRect.height / endRect.height;
        clone.style.transformOrigin = 'top left';
        clone.style.transition = 'transform 0.45s cubic-bezier(0.4, 0, 1, 1), opacity 0.45s ease';
        clone.style.transform = `translate(${dx}px, ${dy}px) scale(${sx}, ${sy})`;
        clone.style.opacity = '0';
        lightbox.style.transition = 'background 0.45s ease';
        lightbox.style.background = 'rgba(14,14,14,0)';
        setTimeout(() => {
          lightbox.setAttribute('aria-hidden', 'true');
          lbInner.innerHTML = '';
          lightbox.style.background = '';
          lightbox.style.transition = '';
          document.body.style.overflow = '';
          openTrigger = null;
        }, 460);
      } else {
        lightbox.setAttribute('aria-hidden', 'true');
        lbInner.innerHTML = '';
        document.body.style.overflow = '';
        openTrigger = null;
      }
    }

    triggers.forEach(b => b.addEventListener('click', () => openZoom(b)));
    closeBtn?.addEventListener('click', closeZoom);
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) closeZoom();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') === 'false') closeZoom();
    });

    // ---------- Reveal observer (jhero-globalが拾わない場合の保険) ----------
    if (!reduceMotion) {
      const io = new IntersectionObserver((entries, obs) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      pdp.querySelectorAll('.j-reveal').forEach(el => io.observe(el));
    }
  });
})();
